module.exports = __webpack_public_path__ + "static/bundleofjoy-ca67066c19a4cd48f84b53e332c36504.jpeg";